"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPracticeProblemSyncDataMultiPart = exports.isPracticeProblemUserOnlyMetadataMultiPart = exports.isProblemSinglePartUser = exports.isProblemSinglePart = exports.isProblemShortAnswerUser = exports.isProblemShortAnswer = exports.isProblemMultipleChoiceUser = exports.isProblemMultipleChoice = exports.isProblemMultiPartUser = exports.isProblemMultiPart = void 0;
const consts_1 = require("./consts");
const isProblemMultiPart = (problem) => {
    return problem.type === consts_1.PracticeProblemType.MULTI_PART;
};
exports.isProblemMultiPart = isProblemMultiPart;
const isProblemMultiPartUser = (problem) => {
    return problem.type === consts_1.PracticeProblemType.MULTI_PART;
};
exports.isProblemMultiPartUser = isProblemMultiPartUser;
const isProblemMultipleChoice = (problem) => {
    return problem.type === consts_1.PracticeProblemType.MULTIPLE_CHOICE;
};
exports.isProblemMultipleChoice = isProblemMultipleChoice;
const isProblemMultipleChoiceUser = (problem) => {
    return problem.type === consts_1.PracticeProblemType.MULTIPLE_CHOICE;
};
exports.isProblemMultipleChoiceUser = isProblemMultipleChoiceUser;
const isProblemShortAnswer = (problem) => {
    return problem.type === consts_1.PracticeProblemType.SHORT_ANSWER;
};
exports.isProblemShortAnswer = isProblemShortAnswer;
const isProblemShortAnswerUser = (problem) => {
    return problem.type === consts_1.PracticeProblemType.SHORT_ANSWER;
};
exports.isProblemShortAnswerUser = isProblemShortAnswerUser;
const isProblemSinglePart = (problem) => {
    return !(0, exports.isProblemMultiPart)(problem);
};
exports.isProblemSinglePart = isProblemSinglePart;
const isProblemSinglePartUser = (problem) => {
    return !(0, exports.isProblemMultiPartUser)(problem);
};
exports.isProblemSinglePartUser = isProblemSinglePartUser;
const isPracticeProblemUserOnlyMetadataMultiPart = (practiceProblemUserOnlyMetadata) => {
    return 'subProblemUserOnlyMetadata' in practiceProblemUserOnlyMetadata;
};
exports.isPracticeProblemUserOnlyMetadataMultiPart = isPracticeProblemUserOnlyMetadataMultiPart;
const isPracticeProblemSyncDataMultiPart = (practiceProblemSyncData) => {
    return 'subProblemUserOnlyMetadata' in practiceProblemSyncData;
};
exports.isPracticeProblemSyncDataMultiPart = isPracticeProblemSyncDataMultiPart;
//# sourceMappingURL=typeguards.js.map